import { Link } from "react-router-dom";
import { routes } from "routes";
import React from "react";

export const FileSizeError = () => (
  <div>
    The file is too big.<br />
    Our uploading requirements and rules can be found <Link to={routes.faq()}>here</Link>.
  </div>
);
